import React, { useEffect, useState } from 'react';

const PrintBusExpenses = () => {
    const [report, setReport] = useState(null);

    useEffect(() => {
        const storedReport = localStorage.getItem('print_bus_expenses_report');
        if (storedReport) {
            setReport(JSON.parse(storedReport));
        }
        
        const timer = setTimeout(() => {
            window.print();
        }, 800);

        return () => clearTimeout(timer);
    }, []);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('fr-MA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount || 0);
    };

    if (!report) return <div className="text-center p-10">جاري تحميل البيانات...</div>;

    const formatDate = (dateString) => {
        if (!dateString) return '';
        try {
            const parts = dateString.split('T')[0].split('-');
            if (parts.length === 3) {
                return `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
            return dateString;
        } catch (e) {
            return dateString;
        }
    };

    const { buses_report, grand_total, print_start_date, print_end_date } = report;
    
    const startDate = print_start_date ? formatDate(print_start_date) : '';
    const endDate = print_end_date ? formatDate(print_end_date) : '';

    return (
        <div className="print-container">
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                <img src="/logo.png" alt="Logo" style={{ width: '100px', height: '100px', objectFit: 'contain', display: 'block', margin: '0 auto 10px auto' }} />
            </div>

            <div className="header-text">
                <div style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '8px' }}>تقرير مصاريف الحافلات</div>
                {(startDate || endDate) && (
                    <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {startDate && endDate ? `خلال الفترة الممتدة ما بين ${startDate} إلى غاية ${endDate}` : ''}
                        {startDate && !endDate ? `ابتداء من ${startDate}` : ''}
                        {!startDate && endDate ? `إلى غاية ${endDate}` : ''}
                    </div>
                )}
            </div>

            <table className="excel-table">
                <thead>
                    <tr>
                        <th style={{ width: '30%' }}>رقم الحافلة</th>
                        <th style={{ width: '40%' }}>نوع المصاريف</th>
                        <th style={{ width: '30%' }}>مبلغ المصاريف</th>
                    </tr>
                </thead>
                <tbody>
                    {buses_report.map((busReport, idx) => (
                        <React.Fragment key={idx}>
                            {busReport.expenses.map((exp, expIdx) => (
                                <tr key={`${idx}-${expIdx}`}>
                                    {expIdx === 0 && (
                                        <td className="text-center font-bold" rowSpan={busReport.expenses.length} style={{ verticalAlign: 'middle' }}>
                                            {busReport.bus_matricule}
                                        </td>
                                    )}
                                    <td className="text-center">{exp.type_name}</td>
                                    <td className="text-center font-bold">{formatCurrency(exp.amount)}</td>
                                </tr>
                            ))}
                            <tr className="bus-total-row">
                                <td colSpan="2" className="text-center font-bold">مجموع مصاريف {busReport.bus_matricule}</td>
                                <td className="text-center font-bold">{formatCurrency(busReport.total)}</td>
                            </tr>
                        </React.Fragment>
                    ))}
                    
                    {buses_report.length === 0 && (
                        <tr>
                            <td colSpan="3" className="text-center" style={{ padding: '20px' }}>لا توجد مصاريف مسجلة في هذه الفترة</td>
                        </tr>
                    )}
                </tbody>
                {buses_report.length > 0 && (
                    <tfoot>
                        <tr className="final-result-row">
                            <td colSpan="2" className="text-center font-bold">مجموع مصاريف الحافلات</td>
                            <td className="text-center font-bold">{formatCurrency(grand_total)}</td>
                        </tr>
                    </tfoot>
                )}
            </table>

            <style dangerouslySetInnerHTML={{__html: `
                @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700&display=swap');
                
                body {
                    margin: 0;
                    padding: 0;
                    background: white;
                }

                .print-container {
                    width: 80%;
                    min-height: 297mm;
                    padding: 20mm;
                    margin: 0 auto;
                    direction: rtl;
                    font-family: 'Cairo', Arial, sans-serif;
                    box-sizing: border-box;
                    color: #000;
                }

                .header-text {
                    text-align: center;
                    margin-bottom: 40px;
                }

                .excel-table {
                    width: 100%;
                    margin: 0 auto 10px auto;
                    border-collapse: collapse;
                    border: 1px solid #000;
                }

                .excel-table th, .excel-table td {
                    border: 1px solid #000;
                    padding: 8px 12px;
                    font-size: 16px;
                }

                .excel-table th {
                    text-align: center;
                    font-weight: bold;
                    background-color: #fff;
                    color: #000;
                }

                .bus-total-row td {
                    background-color: #f9f9f9;
                    font-weight: bold;
                }

                .final-result-row td {
                    background-color: #f0f0f0;
                    font-size: 18px;
                    padding: 12px;
                    font-weight: bold;
                }

                .text-right { text-align: right !important; }
                .text-center { text-align: center !important; }
                .font-bold { font-weight: bold !important; }

                @media print {
                    @page { margin: 0; size: A4 portrait; }
                    body { background: none; }
                    .print-container { 
                        width: 100%;
                        height: 100%;
                        padding: 15mm; 
                        margin: 0;
                        box-shadow: none;
                    }
                    .excel-table th {
                        background-color: #fff !important;
                        -webkit-print-color-adjust: exact;
                        color-adjust: exact;
                    }
                }
            `}} />
        </div>
    );
};

export default PrintBusExpenses;
